import { useEffect, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router';
import {
  BackButton,
  Box,
  Center,
  FloatingContainer,
  Row,
  Screen,
  Stepper,
  Text,
} from '~/commonComponents';

export const CreatePermanentJobsTemplate = () => {
  const location = useLocation();

  // Scroll to top on navigation
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [location.pathname]);

  const currentStepIndex = useMemo(() => {
    const pathname = location.pathname;

    if (pathname.includes('/working-interviews')) {
      return 1;
    } else if (pathname.includes('/review-and-payment')) {
      return 2;
    } else {
      return 0;
    }
  }, [location.pathname]);

  return (
    <Screen>
      <FloatingContainer borderRadius={4} paddingBlock={48} paddingInline={16}>
        <Row position="relative" alignItems="center" justifyContent="center">
          <Box position="absolute" left={0}>
            <BackButton />
          </Box>
          <Text bold fontSize={32} textAlign="center">
            Post a Job
          </Text>
        </Row>
        <Center marginTop={24} width={640} marginBottom={40}>
          <Stepper
            currentStep={currentStepIndex}
            steps={['Job Details', 'Working Interviews', 'Review and Payment']}
          />
        </Center>
        <Outlet />
      </FloatingContainer>
    </Screen>
  );
};
